import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { totalPrice } from "../../utils";
import { useTranslation } from "react-i18next";
import { useLang } from "../../context/LangContext";
import { useVerifyPayOrder } from "../../api/useApi";
import { toast } from "react-toastify";

const OrderRecivedSec = ({ cartList }) => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderid");
  const paymentId = searchParams.get("id"); // Extract paymentId from URL
  const status = searchParams.get("status"); // Extract payment status from URL

  const [paymentStatus, setPaymentStatus] = useState("pending");

  // Use mutation hook to verify payment
  const verifyPayOrder = useVerifyPayOrder();

  useEffect(() => {
    const verifyPayment = async () => {
      if (orderId && paymentId) {
      if (status === "paid" ) {
        try {
          const response = await verifyPayOrder.mutateAsync({ orderId, paymentId });
          console.log(response);
          toast.success(t("paymentSuccess"));
          setPaymentStatus(response.status);
        } catch (error) {
          toast.error(lang === "ar" ? "حدث خطأ أثناء التحقق من الدفع" : "An error occurred while verifying payment");
          setPaymentStatus("Failed");
        }
      } else {
        setPaymentStatus("Failed");
        toast.error(lang === "ar" ? "حدث خطأ أثناء التحقق من الدفع" : "An error occurred while verifying payment");
      }
      } else {
        setPaymentStatus("Failed");
        toast.success(lang === "ar" ? "تم استلام الطلب بنجاح" : "Order received successfully");
      }
    };

    verifyPayment();
  }, [orderId, paymentId, status]);

  // useEffect(() => {
  //   const verifyPayment = async () => {
  //     console.log("message:", message);
  //     if (orderId && paymentId && status && message) {
  //       if (message === "success") {
  //         setPaymentStatus("success");
  //         toast.success(lang === "ar" ? "تم استلام الطلب بنجاح" : "Order received successfully");
  //         return;
  //       }
  //       switch (message) {
  //         case "Y":
  //           try {
  //             const response = await verifyPayOrder.mutateAsync({ orderId, paymentId });
  //             setPaymentStatus(response.status);
  //             toast.success(t("paymentSuccess"));
  //           } catch (error) {
  //             setPaymentStatus("error");
  //             toast.error(t("paymentError"));
  //           }
  //           break;
  //         case "N":
  //           setPaymentStatus("failed");
  //           toast.error(t("transactionDenied"));
  //           break;
  //         case "U":
  //           setPaymentStatus("unavailable");
  //           toast.warning(t("authNotAvailable"));
  //           break;
  //         case "3DS: 3A The authentication attempt was rejected by the issuer bank.":
  //           setPaymentStatus("rejected");
  //           toast.error(t("paymentRejected"));
  //           break;
  //         case "E":
  //           setPaymentStatus("error");
  //           toast.error(t("serverError"));
  //           break;
  //         default:
  //           setPaymentStatus("cancelled");
  //           toast.info(t("paymentCancelled"));
  //       }
  //     } else {
  //       setPaymentStatus("failed");
  //       toast.success(lang === "ar" ? "تم استلام الطلب بنجاح" : "Order received successfully");
  //     }
  //   };

  //   verifyPayment();
  // }, [orderId, paymentId, status]);


  return (
    <section className="cart-recived-section section-padding">
      <div className="container">
        <div className="row">
          <div className="order-top">
            <h2>
              <span>{orderId && paymentId && status ? ((paymentStatus === "success" || paymentStatus === "pending") ? t("OrderRecived") : t("paymentError")) : ""}</span>
            </h2>
            <Link to="/home" className="theme-btn">{t("back")}</Link>
          </div>
          <Grid className="cartStatus" dir={lang === "ar" ? "rtl" : "ltr"}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Grid className="cartTotals">
                  <h4>{t("orderDetails")}</h4>
                  <Table>
                    <TableBody>
                      {cartList.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell align={lang === "ar" ? "right" : "left"}>
                            <img src={item.proImg} alt="" style={{ width: "40px", height: "40px", objectFit: "cover", verticalAlign: "middle" }} />
                            <div style={{ display: "inline-block", verticalAlign: "middle", marginLeft: "10px" }}>
                              <span style={{ fontSize: "15px", fontWeight: 500, color: "#333", whiteSpace: "nowrap" }}>
                                {item.title} {item.price} × {item.qty} {t("currency")}
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow className="totalProduct">
                        <TableCell align={lang === "ar" ? "right" : "left"}>{t("totalProduct")}</TableCell>
                        <TableCell align={lang === "ar" ? "left" : "right"}>{cartList.length}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align={lang === "ar" ? "right" : "left"}>{t("subPrice")}</TableCell>
                        <TableCell align={lang === "ar" ? "left" : "right"}>{totalPrice(cartList)} {t("currency")}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align={lang === "ar" ? "right" : "left"}><b>{t("totalPrice")}</b></TableCell>
                        <TableCell align={lang === "ar" ? "left" : "right"}><b>{totalPrice(cartList)} {t("currency")}</b></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </section>
  );
};

export default OrderRecivedSec;
